import React from "react";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";

import { ConfirmModal, IMediaPlaylistReference } from "../../libs";
import { vodService } from "../../services";

interface ShowMediaDeleteConfirmationOptions {
  mediaId: string;
  onConfirm: () => Promise<void>;
}

export const showMediaDeleteConfirmation = async ({
  mediaId,
  onConfirm,
}: ShowMediaDeleteConfirmationOptions) => {
  let playlists: IMediaPlaylistReference[];

  try {
    playlists = await vodService.getMediaItemPlaylists(mediaId);
  } catch {
    toast.error("The video's playlists could not be checked. Please try again.");
    return;
  }

  confirmAlert({
    customUI: ({ onClose }) => (
      <ConfirmModal
        title="Confirm Video Removal"
        description={
          playlists.length > 0
            ? [
                {
                  text: `This video is part of ${playlists.length} playlist${playlists.length === 1 ? "" : "s"}:`,
                  bold: false,
                },
                {
                  text: "If you continue, the video will be permanently deleted and removed from all of these playlists.",
                  bold: true,
                },
              ]
            : [
                {
                  text: "This video is not part of any playlists.",
                  bold: false,
                },
                {
                  text: "This operation is permanent and cannot be reverted.",
                  bold: true,
                },
              ]
        }
        customContent={
          playlists.length > 0 ? (
            <ul>
              {playlists.map((playlist) => (
                <li key={playlist.playlistId}>{playlist.title || "Untitled playlist"}</li>
              ))}
            </ul>
          ) : undefined
        }
        noText="Cancel"
        yesText="Delete Video"
        onNo={onClose}
        onYes={async () => {
          try {
            await onConfirm();
            toast.success(
              playlists.length > 0
                ? "Video deleted and removed from its playlists."
                : "Video deleted successfully."
            );
            onClose();
          } catch {
            toast.error("The video could not be deleted. Please try again.");
          }
        }}
        danger
      />
    ),
    closeOnEscape: true,
    closeOnClickOutside: false,
    keyCodeForClose: [8, 32],
  });
};
